import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../assets/images/home_logo@2x.png";
import { SquareButton } from "../common";

import { useDispatch } from "react-redux";
import { openModal } from "../../redux/ModalSlice";
import { FAQ_URL, MODAL_PAYLOAD, QUESTION_URL } from "../../constants";
import { useQueryClient } from "@tanstack/react-query";
import noticeManager from "../../apis/notice";
import IcDownload from "../../assets/images/icons/ic-download@2x.png";
import IcScript from "../../assets/images/icons/ic-script-fill.png";
import IcQuestion from "../../assets/images/icons/ic-question@2x.png";
import IcQuestion2 from "../../assets/images/icons/ico_question.svg";

import downloadManager from "../../apis/downloadManager";
import { useQuery } from "@tanstack/react-query";
import paymentManager from "../../apis/paymentManager";
const Header = () => {
    const dispatch = useDispatch();
    const useQueryCli = useQueryClient();
    const navigate = useNavigate();
    const installScript = async () => {
        const result = await useQueryCli.getQueryData(["paymentInfo"]);
        const props = JSON.parse(JSON.stringify(MODAL_PAYLOAD.SCRIPT_INSTALL));
        props.modalProps.install_src = result.install_src;
        dispatch(openModal({ ...props }));
    };

    const { data: paymentInfo } = useQuery({
        queryKey: ["paymentInfo"],
        queryFn: paymentManager.getPayment,
    });

    const deleteScript = async () => {
        const props = JSON.parse(JSON.stringify(MODAL_PAYLOAD.SCRIPT_DELETE));
        props.modalProps.script_src = paymentInfo?.script_src;
        dispatch(openModal({ ...props }));
    };

    const downloadManual = async () => {
        const result = await downloadManager.downloadManual();
    };

    const openFAQ = () => {
        window.open(FAQ_URL, "_blank");
    };

    const goToInquire = () => {
        navigate("/inquire");
    };

    const goToNotice = () => {
        navigate("/notice-list");
    };

    const goToQuestion = () => {
        window.open(QUESTION_URL, "_blank");
    }

    const { data: list, isLoading } = useQuery({
        queryKey: ["readNotice"],
        queryFn: noticeManager.getNotice,
    });
    const [unReadNotice, setUnReadNotice] = useState(null);
    useEffect(() => {
        if (!isLoading && list) {
            const unreadNoticesLst = list.notice?.filter(
                (item) => item.read_confirm === false
            );
            setUnReadNotice(unreadNoticesLst);
        }
    }, [isLoading, list]);

    // useEffect(() => {
    //     if (location.pathname === "/") {
    //         deleteScript();
    //     }
    // }, [paymentInfo, location.pathname]);

    return (
        <HeaderContainer>
            <Link to={"/"}>
                <img id={"logo"} src={Logo} alt="logo" />
            </Link>

            <HeaderBtnWrap>
                <SquareButton
                    onClick={goToQuestion}
                    icon={IcQuestion2}
                    customBg="#ED7927"
                    customText="#FBF0D6"
                >
                    카드변경 도움말보기
                </SquareButton>
                <SquareButton onClick={goToNotice} size="inquire">
                    공지사항
                    {unReadNotice && unReadNotice.length > 0 ? (
                        <span className={"chk-read-count"}>N</span>
                    ) : (
                        <></>
                    )}
                </SquareButton>
                <SquareButton onClick={goToInquire} size="inquire">
                    문의하기
                </SquareButton>
                <SquareButton onClick={installScript} icon={IcScript}>
                    스크립트 가이드
                </SquareButton>
                <SquareButton onClick={downloadManual} icon={IcDownload}>
                    매뉴얼 다운로드
                </SquareButton>
                <SquareButton onClick={openFAQ} icon={IcQuestion}>
                    사용 FAQ
                </SquareButton>
            </HeaderBtnWrap>
        </HeaderContainer>
    );
};

const HeaderContainer = styled.section`
    min-width: 660px;
    position: fixed;
    z-index: 20;
    top: 0;
    left: 0;
    background-color: var(--primary-1000);
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 32px;

    img#logo {
        width: 46px;
    }
`;

const HeaderBtnWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 0 8px;
    button {
        position: relative;
    }
    .chk-read-count {
        position: absolute;
        width: 23px;
        height: 23px;
        background-color: #7386e8;
        border-radius: 50%;
        top: -19px;
        right: -32px;
        color: #fff;
        font-size: 12px;
        font-weight: 700;
    }
`;

export default Header;
